import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

/** データなし・未実装・権限なしなどの案内 */
export function EmptyState({ icon, title, description, action, compact }: EmptyStateProps) {
  return (
    <div className={cx('bs-empty', compact && 'is-compact')}>
      {icon && (
        <div className="bs-empty__icon" aria-hidden>
          {icon}
        </div>
      )}
      <div className="bs-empty__title">{title}</div>
      {description && <div className="bs-empty__desc">{description}</div>}
      {action && <div className="bs-empty__action">{action}</div>}
    </div>
  );
}
